export const PIDStaticPropOptions = [
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Drilling Specification",
    Value: "End of Drilling - Threaded lug",
  },
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Drilling Specification",
    Value: "Normal Drilling - all other instances",
  },
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Chain",
  },
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Electric Actuator",
  },
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Stem Cap",
  },
  {
    ClassName: "Butterfly Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Hand Wheel",
  },

  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Drilling Specification",
    Value: "End of Drilling - Threaded lug",
  },
  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Drilling Specification",
    Value: "Normal Drilling - all other instances",
  },
  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Chain",
  },
  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Electric Actuator",
  },
  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Stem Cap",
  },
  {
    ClassName: "Butterfly Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Hand Wheel",
  },

  {
    ClassName: "Dual Contained Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Dual Contained Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Dual Contained Pipeline",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Dual Contained Pipeline",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Dual Contained Pipeline",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Electromagnetic",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Flow Nozzle",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - General",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - General",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - General",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - General",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - General",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Flow - General",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - General",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Orifice Plate",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Pitot Tube",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Rotary Displacement",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Sight Glass",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Turbine / Rotary",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Variable Area",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Instrument Type",
    Value: "Flow Indicator",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Instrument Type",
    Value: "Flow Switch",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Instrument Type",
    Value: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Instrument Type",
    Value: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Flow - Venturi Tube",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the instrument is installed in",
  },

  {
    ClassName: "Future Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Future Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Future Pipeline",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Future Pipeline",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Future Pipeline",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Drilling Specification",
    Value: "End of Drilling - Threaded lug",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Drilling Specification",
    Value: "Normal Drilling - all other instances",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Gear Box Required",
    Value: "Yes",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Gear Box Required",
    Value: "No",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Chain",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Electric Actuator",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Stem Cap",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Head Works Specification",
    Value: "Hand Wheel",
  },

  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Valve Orientation",
    Value: "Any Orientation - use for wedge gate valves",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Valve Orientation",
    Value: "Horizontal Only",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Valve Orientation",
    Value: "Vertical Only",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Valve Type",
    Value: "Gate Valve",
  },
  {
    ClassName: "Gate Valve (Closed)",
    PropertyName: "Valve Type",
    Value: "Knife Gate Valve",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Drilling Specification",
    Value: "End of Drilling - Threaded lug",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Drilling Specification",
    Value: "Normal Drilling - all other instances",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Gear Box Required",
    Value: "Yes",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Gear Box Required",
    Value: "No",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Chain",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Electric Actuator",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Stem Cap",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Head Works Specification",
    Value: "Hand Wheel",
  },

  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Valve Orientation",
    Value: "Any Orientation - use for wedge gate valves",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Valve Orientation",
    Value: "Horizontal Only",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Valve Orientation",
    Value: "Vertical Only",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Valve Type",
    Value: "Gate Valve",
  },
  {
    ClassName: "Gate Valve (Open)",
    PropertyName: "Valve Type",
    Value: "Knife Gate Valve",
  },

  {
    ClassName: "Level - Displacer",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Instrument Type",
    Value: "Level Switch",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Displacer",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Electrode (Capacitive)",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Electrode (Capacitive)",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Electrode (Capacitive)",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Electrode (Capacitive)",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Electrode (Capacitive)",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Electrode (Conductive)",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Electrode (Conductive)",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Electrode (Conductive)",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Electrode (Conductive)",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Electrode (Conductive)",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Float",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - Float",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Float",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Float",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Float",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - General",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Instrument Type",
    Value: "Level Switch",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - General",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Instrument Type",
    Value: "Level Switch",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Membrane (Diaphragm)",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Instrument Type",
    Value: "Level Switch",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Resistance (Strain Gauge)",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Instrument Type",
    Value: "Level Float",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Instrument Type",
    Value: "Level Probe",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Instrument Type",
    Value: "Level Switch",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Sight Glass (Tank Level)",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },

  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Instrument Type",
    Value: "Level Ultrasonic Borehole",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Sensor Mount Type",
    Value: "NA",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Sensor Mount Type",
    Value: "Fixed",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Sensor Mount Type",
    Value: "Hinged",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Transmitter Mounting Location",
    Value: "NA",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Transmitter Mounting Location",
    Value: "Field",
  },
  {
    ClassName: "Level - Ultrasonic",
    PropertyName: "Transmitter Mounting Location",
    Value: "Remote",
  },

  {
    ClassName: "Major Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Major Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Major Pipeline",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Major Pipeline",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Major Pipeline",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Major Pipeline - Existing",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Major Pipeline - Existing",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Major Pipeline - Existing",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Major Pipeline - Existing",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Major Pipeline - Existing",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Minor Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Minor Pipeline",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Minor Pipeline",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Minor Pipeline",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Minor Pipeline",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Minor Pipeline - Existing",
    PropertyName: "Above Ground/Below Ground",
    Value: "AG",
  },
  {
    ClassName: "Minor Pipeline - Existing",
    PropertyName: "Above Ground/Below Ground",
    Value: "BG",
  },
  {
    ClassName: "Minor Pipeline - Existing",
    PropertyName: "Fluid Code",
    Value: "Refer to 'Fluid Codes' drop tool key",
  },

  {
    ClassName: "Minor Pipeline - Existing",
    PropertyName: "Maximum Fluid Operation Pressure (barg)",
    Value: "-1 to 16 barg",
  },
  {
    ClassName: "Minor Pipeline - Existing",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "OD for plastic pipes - NB for all others",
  },

  {
    ClassName: "Pressure",
    PropertyName: "Instrument Type",
    Value: "Pressure Indicator",
  },
  {
    ClassName: "Pressure",
    PropertyName: "Instrument Type",
    Value: "Pressure Sensor",
  },
  {
    ClassName: "Pressure",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Pressure",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Pressure",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the insturment is installed in",
  },

  {
    ClassName: "Pressure Differential",
    PropertyName: "Instrument Type",
    Value: "Pressure Indicator",
  },
  {
    ClassName: "Pressure Differential",
    PropertyName: "Instrument Type",
    Value: "Pressure Sensor",
  },
  {
    ClassName: "Pressure Differential",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Pressure Differential",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Pressure Differential",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the insturment is installed in",
  },

  {
    ClassName: "Pressure With Mechanical Indicator",
    PropertyName: "Instrument Type",
    Value: "Pressure Indicator",
  },
  {
    ClassName: "Pressure With Mechanical Indicator",
    PropertyName: "Instrument Type",
    Value: "Pressure Sensor",
  },
  {
    ClassName: "Pressure With Mechanical Indicator",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Pressure With Mechanical Indicator",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
  {
    ClassName: "Pressure With Mechanical Indicator",
    PropertyName: "Size (NB or OD) (mm or inches)",
    Value: "Size of the line the insturment is installed in",
  },

  {
    ClassName: "Quality - Acidity",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Acidity",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Acidity",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Ammonia",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Ammonia",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Ammonia",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Conductivity",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Conductivity",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Conductivity",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Dissolved Oxygen",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Dissolved Oxygen",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Dissolved Oxygen",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Free Chlorine",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Free Chlorine",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Free Chlorine",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - General",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - General",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - General",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Iron",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Iron",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Iron",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Nitrates",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Nitrates",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Nitrates",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Phosphates",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Phosphates",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Phosphates",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Suspended Solids",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Suspended Solids",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Suspended Solids",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Total Chlorine",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Total Chlorine",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Total Chlorine",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Turbidity",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Turbidity",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Turbidity",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },

  {
    ClassName: "Quality - Ultra-Violet Transmissivity",
    PropertyName: "Instrument Type",
    Value: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Ultra-Violet Transmissivity",
    PropertyName: "Process Range - Maximum",
    Value: "The maximum of the instrument's operating range",
  },
  {
    ClassName: "Quality - Ultra-Violet Transmissivity",
    PropertyName: "Process Range - Minimum",
    Value: "The minimum of the instrument's operating range",
  },
];
